import { ComponentType } from '@interfaces/component-type';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Icon, Input, Modal, Row, Select } from 'antd';
import React from 'react';

import { ConditionWithComponent } from './conditions-components/ConditionCompareComponent';
import { ConditionWithValue } from './conditions-components/ConditionCompareValue';
import { ConditionWithValueWithoutProp } from './conditions-components/ConditionCompareValueWithoutXProp';
import ConfirmConditionComponent from './conditions-components/ConfirmConditionComponent';
import IBaseComponent from './Interfaces/Base/IBaseComponent';
import ISection from './Interfaces/ISection';
import ISectionCondition, {
  ComponentProp,
  IComponentValue,
  ISectionConditionRole,
  OperatorType,
} from './Interfaces/ISectionCondition';
import FormflowContext from './Util/FormflowContext';


const Option = Select.Option;
let validationConditions: boolean[] = []

export class SectionRule implements ISectionConditionRole {
  compare?: string;
  xItem: IComponentValue;
  operator: OperatorType ;
  yItem?: IComponentValue;
  value?: any;

  constructor() {
    this.compare = undefined;
    this.operator = -1;
    this.value = undefined;
    this.xItem = {
      id: '',
      prop: -1
    };
    this.yItem = {
      id: '',
      prop: 3
    }
    return this;
  }
}

export class SectionCondition implements ISectionCondition {
  id: string | undefined;
  rules: any;
  sectionId: string | undefined

  constructor() {
    this.id = undefined
    this.rules = [{
      operator: undefined,
      value: undefined,
      xItem: {
        id: undefined,
        prop: undefined
      },
      yItem: {
        id: undefined,
        prop: 3
      }
    }];
    this.sectionId = undefined;
    return this;
  }
}

interface IConditionSectionFormflowPropType {
  modalVisible: boolean;
  onCloseModal: Function;
  titleConditionModal: string;
  subtitleConditionModal: string;
  selectComponentCondition: IBaseComponent[];
  sectionLinkedCondition: string[];
  titleComponentCondition: Function;
  titleRadioConfirmYes?: string;
  titleRadioConfirmNo?: string;
  currentSection: ISection

};
interface IConditionSectionFormflowStateType {
  conditionsSections: any;
  operator: number;
  value?: any;
  idXItem: string;
  propsXItem: number;
  idYItem: string | null;
  propsYItem: number;
  sectionId: string | null;
  valueSelectCompare: string;
  currentComponentCondition: any;
  rules: any;
  compareValue: string;
  validationConditions: boolean[]
};

export default class ConditionSectionFormflow extends React.Component<IConditionSectionFormflowPropType, IConditionSectionFormflowStateType> {
  constructor(props: IConditionSectionFormflowPropType) {
    super(props);
    this.state = {
      conditionsSections: [new SectionCondition()],
      operator: 3,
      value: undefined,
      idXItem: '',
      propsXItem: 0,
      idYItem: null,
      propsYItem: 0,
      sectionId: null,
      valueSelectCompare: '',
      currentComponentCondition: '',
      rules: [new SectionRule()],
      compareValue: '',
      validationConditions: []
    };

    this.bindFunctions();
  }

  componentDidMount = async () => {
    if (this.props.currentSection.conditions) {
      if (this.props.currentSection.conditions !== null || this.props.currentSection.conditions !== undefined) {
        this.setState({ conditionsSections: this.props.currentSection.conditions })
      }
    }
    else {
      this.setState({ conditionsSections: [new SectionCondition()] })
    }

    const newRules = Object.assign({}, this.state.conditionsSections);
    if (this.state.conditionsSections !== undefined) {
      await this.state.conditionsSections.forEach((conditions: any, idxCondition: number) => {
        conditions.rules.forEach((rulesItems: any, idxRule: number) => {

          if (rulesItems.value === undefined) {
            newRules[idxCondition].rules[idxRule].compare = 'component'
          }
          else if (rulesItems.yItem === null || rulesItems.yItem === undefined) {
            newRules[idxCondition].rules[idxRule].compare = 'value'
          }
          if (rulesItems.value === true || rulesItems.value === false) {
            newRules[idxCondition].rules[idxRule].yItem = null
          }
        })
      })
      this.setState({ conditionsSections: this.state.conditionsSections })
      console.log('conditions', this.state.conditionsSections)
    }
  }

  bindFunctions() {
    this.onChangeSelectComponetCondition = this.onChangeSelectComponetCondition.bind(this)
  }

  onChangeSelectComponetCondition = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].compare = I18n.l("formflow.conditions.selectOptionPlaceholder")
    newRules[idxCondition].rules[idxRule].xItem.id = evt
    this.setState({
      conditionsSections: this.state.conditionsSections,
      idXItem: evt
    })
  }
  //#region Condition CONFIRM
  onChangeValueComponetCondition = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].value = evt.target.value
    newRules[idxCondition].rules[idxRule].operator = OperatorType.Equals
    newRules[idxCondition].rules[idxRule].xItem.id = this.state.idXItem
    newRules[idxCondition].rules[idxRule].xItem.prop = 3
    newRules[idxCondition].rules[idxRule].yItem = null
    this.setState({ conditionsSections: this.state.conditionsSections })
  }
  //#endregion

  //#region Condition TEXT
  onChangeOption = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].xItem.id = this.state.idXItem
    newRules[idxCondition].rules[idxRule].xItem.prop = evt
    this.setState({
      conditionsSections: this.state.conditionsSections,
      propsXItem: evt
    })
  }
  onChangeOptionCompare = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].operator = evt
    this.setState({ conditionsSections: this.state.conditionsSections })
  }
  onChangeOptionCompareWithoutXProp = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].operator = evt
    newRules[idxCondition].rules[idxRule].xItem.prop = ComponentProp.VALUE
    this.setState({ conditionsSections: this.state.conditionsSections })
  }
  onChangeComponent = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].yItem.id = evt
    newRules[idxCondition].rules[idxRule].yItem.prop = ComponentProp.VALUE
    this.setState({ conditionsSections: this.state.conditionsSections })
  }
  onChangeValue = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].value = evt.target.value
    newRules[idxCondition].rules[idxRule].yItem = null
    this.setState({ conditionsSections: this.state.conditionsSections })
  }

  onChangeValueSelect = (idxCondition: any, idxRule: number, currentComponentCondition: any) => async (evt: any) => {
    const idxSelectValue = currentComponentCondition.options.findIndex((x: any) => x.value === evt)
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].value = idxSelectValue
    newRules[idxCondition].rules[idxRule].yItem = null
    this.setState({ conditionsSections: this.state.conditionsSections })
  }
  onChangeValueNumber = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].value = evt
    this.setState({ conditionsSections: this.state.conditionsSections })
  }
  //#endregion

  onChangeSelectLinkCondition = (idx: any) => async (evt: any) => {
    const newConditionsSection =
      this.state.conditionsSections.map((conditionsSectionItems: any, sidx: any) => {
        if (idx !== sidx) return conditionsSectionItems;
        return { ...conditionsSectionItems, sectionId: evt };
      });
    this.setState({
      conditionsSections: newConditionsSection,
    });
  }
  onChangeNameCondition = (idx: any) => async (evt: any) => {
    const newConditionsSection =
      this.state.conditionsSections.map((conditionsSectionItems: any, sidx: any) => {
        if (idx !== sidx) return conditionsSectionItems;
        return { ...conditionsSectionItems, id: evt.target.value };
      });
    this.setState({
      conditionsSections: newConditionsSection,
    });
    console.log('valor do ID', this.state.conditionsSections)
  }

  onChangeCompareComponents = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules[idxRule].compare = evt
    if (newRules[idxCondition].rules[idxRule].compare === 'component') {
      newRules[idxCondition].rules[idxRule].value = null
      newRules[idxCondition].rules[idxRule].yItem = { id: undefined, prop: ComponentProp.VALUE }
      // newRules[idxCondition].rules[idxRule].yItem.prop = 3
    }
    else if (newRules[idxCondition].rules[idxRule].compare === 'value') {
      newRules[idxCondition].rules[idxRule].yItem = undefined
      newRules[idxCondition].rules[idxRule].value = undefined
    }
    this.setState({ conditionsSections: this.state.conditionsSections })
  }

  handleAddNewRules = async (rules: any, idx: number) => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idx].rules = rules.concat(new SectionRule())
    this.setState({ conditionsSections: this.state.conditionsSections })
  }

  handleAddNewConditionSection = async () => {
    this.setState({
      conditionsSections: this.state.conditionsSections.concat([new SectionCondition()]),
    });
  }

  handleRemoveConditionSection = (index: number) => async () => {
    this.setState({
      conditionsSections: this.state.conditionsSections.filter((section: any, sindex: number) => index !== sindex),
      validationConditions: []
    });
  }

  handleRemoveRules = (idxCondition: number, idxRule: number, rules: any) => async () => {
    const newRules = Object.assign({}, this.state.conditionsSections);
    newRules[idxCondition].rules = rules.filter((section: any, sindex: number) => idxRule !== sindex)

    this.setState({ conditionsSections: this.state.conditionsSections });
  }

  //#region GetSelect Conditions
  getConditionOptionCompare() {
    const conditionOptionCompare: JSX.Element[] = [];
    conditionOptionCompare.push(
      <Option value={OperatorType.Equals}>{I18n.l("formflow.conditions.equals")} </Option>,
      <Option value={OperatorType.NotEquals}>{I18n.l("formflow.conditions.notEquals")}</Option>,
      <Option value={OperatorType.Contains}>{I18n.l("formflow.conditions.contains")}</Option>,
      <Option value={OperatorType.NotContains}>{I18n.l("formflow.conditions.notContains")}</Option>
    );
    return conditionOptionCompare;
  }

  getConditionOptionAllCompare() {
    const conditionOptionCompare: JSX.Element[] = [];
    conditionOptionCompare.push(
      <Option value={OperatorType.Equals}>{I18n.l("formflow.conditions.equals")}</Option>,
      <Option value={OperatorType.GreaterThan}>{I18n.l("formflow.conditions.greaterThan")} </Option>,
      <Option value={OperatorType.GreaterOrEqualsThan}>{I18n.l("formflow.conditions.greaterThanOrEquals")}</Option>,
      <Option value={OperatorType.LessThan}>{I18n.l("formflow.conditions.lessThan")} </Option>,
      <Option value={OperatorType.LessOrEqualsThan}>{I18n.l("formflow.conditions.lessThanOrEquals")}</Option>,
      <Option value={OperatorType.NotEquals}>{I18n.l("formflow.conditions.notEquals")}</Option>,
      <Option value={OperatorType.Contains}>{I18n.l("formflow.conditions.contains")}</Option>,
      <Option value={OperatorType.NotContains}>{I18n.l("formflow.conditions.notContains")}</Option>
    );
    return conditionOptionCompare;
  }
  getConditionOptionCompareCount() {
    const conditionOptionCompareCount: JSX.Element[] = [];
    conditionOptionCompareCount.push(
      <Option value={OperatorType.Equals}>{I18n.l("formflow.conditions.equals")}</Option>,
      <Option value={OperatorType.GreaterThan}>{I18n.l("formflow.conditions.greaterThan")} </Option>,
      <Option value={OperatorType.GreaterOrEqualsThan}>{I18n.l("formflow.conditions.greaterThanOrEquals")}</Option>,
      <Option value={OperatorType.LessThan}>{I18n.l("formflow.conditions.lessThan")} </Option>,
      <Option value={OperatorType.LessOrEqualsThan}>{I18n.l("formflow.conditions.lessThanOrEquals")}</Option>,
      <Option value={OperatorType.NotEquals}>{I18n.l("formflow.conditions.notEquals")}</Option>,
    );
    return conditionOptionCompareCount;
  }
  getConditionOptionCompareSelect() {
    const conditionOptionCompareCount: JSX.Element[] = [];
    conditionOptionCompareCount.push(
      <Option value={OperatorType.Equals}>{I18n.l("formflow.conditions.equals")}</Option>,
      <Option value={OperatorType.NotEquals}>{I18n.l("formflow.conditions.notEquals")}</Option>,
    );
    return conditionOptionCompareCount;
  }
  getSelectItems = (selectItems: any) => {
    const selectItemsList: JSX.Element[] = [];
    selectItems.forEach((itemSelect: any, idx: number) => {
      selectItemsList.push(
        <Option key={idx} value={itemSelect.value}>
          {itemSelect.value}
        </Option>
      );

    })
    return selectItemsList;
  }
  //#endregion

  renderConditionComponent(sectionCondition: any, idxCondition: number, idxRule: number) {
    const currentComponentCondition: any = this.props.selectComponentCondition.find((x: any) => (x.id === sectionCondition.xItem.id))
    if (currentComponentCondition !== undefined) {
      switch (currentComponentCondition.type) {
        case ComponentType.CONFIRM: {
          return (
            <React.Fragment>
              <div>
                <p className="title-component" >{currentComponentCondition.title}</p>
                <ConfirmConditionComponent
                  titleRadioYes={currentComponentCondition.yesLabel}
                  titleRadioNo={currentComponentCondition.noLabel}
                  valueConfirmComponentCondition={sectionCondition.value}
                  handleConfirmConditionChange={() => this.onChangeValueComponetCondition(idxCondition, idxRule)}
                />
              </div>
            </React.Fragment>
          )
        };

        case ComponentType.TEXT: {
          return (
            <React.Fragment>
              <div>
                <p className="title-component" >{currentComponentCondition.title}</p>
                <React.Fragment>
                  <div style={{ marginBottom: '10px', position: "relative" }} id="area">
                    {sectionCondition.compare !== undefined &&
                      <Select defaultValue={sectionCondition.compare} placeholder={I18n.l("formflow.conditions.selectOptionPlaceholder")} style={{ width: "50%", marginBottom: '10px', marginTop: '10px' }}
                        onChange={this.onChangeCompareComponents(idxCondition, idxRule)}
                        getPopupContainer={() => document.getElementById("area")}
                      >
                        <Option value="component">{I18n.l("formflow.conditions.compareComponent")}</Option>
                        <Option value="value">{I18n.l("formflow.conditions.compareValue")}</Option>
                      </Select>
                    }
                    <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}` }} >
                      {sectionCondition.compare !== 'value' && sectionCondition.compare !== 'component' && I18n.l("form.validation.field.required")}
                    </div>
                  </div>
                  {
                    sectionCondition.compare === 'component' &&
                    <div>
                      <ConditionWithComponent
                        selectComponentCondition={this.props.selectComponentCondition}
                        idCurrentConditionComponent={currentComponentCondition.id}
                        getConditionOptionCompare={this.getConditionOptionCompare}
                        onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                        onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                        onChangeComponent={() => this.onChangeComponent(idxCondition, idxRule)}
                        valueOption={sectionCondition.xItem.prop}
                        valueOptionCompare={sectionCondition.operator}
                        valueComponents={sectionCondition.yItem.id}
                      />
                    </div>
                  }
                  {
                    sectionCondition.compare === 'value' &&
                    <ConditionWithValue
                      withoutCount={false}
                      selectComponentCondition={this.props.selectComponentCondition}
                      idCurrentConditionComponent={currentComponentCondition.id}
                      getConditionOptionCompare={this.state.propsXItem === ComponentProp.COUNT ? this.getConditionOptionCompareCount : this.getConditionOptionCompare}
                      onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                      onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                      onChangeValue={() => this.onChangeValue(idxCondition, idxRule)}
                      valueOption={sectionCondition.xItem.prop}
                      valueOptionCompare={sectionCondition.operator}
                      valueInput={sectionCondition.value}
                    />
                  }

                </React.Fragment>
              </div>
            </React.Fragment>
          )
        }
        case ComponentType.GOTO: {
          return (
            <React.Fragment>
              <div>
                <p className="title-component" >{currentComponentCondition.title}</p>
                <React.Fragment>
                  <div style={{ marginBottom: '10px', position: "relative" }} id="area">
                    {sectionCondition.compare !== undefined &&
                      <Select defaultValue={sectionCondition.compare} placeholder={I18n.l("formflow.conditions.selectOptionPlaceholder")} style={{ width: "50%", marginBottom: '10px', marginTop: '10px' }}
                        onChange={this.onChangeCompareComponents(idxCondition, idxRule)}
                        getPopupContainer={() => document.getElementById("area")}
                      >
                        <Option value="component">{I18n.l("formflow.conditions.compareComponent")}</Option>
                        <Option value="value">{I18n.l("formflow.conditions.compareValue")}</Option>
                      </Select>
                    }
                    <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}` }} >
                      {sectionCondition.compare !== 'value' && sectionCondition.compare !== 'component' && I18n.l("form.validation.field.required")}
                    </div>
                  </div>
                  {
                    sectionCondition.compare === 'component' &&
                    <div>
                      <ConditionWithComponent
                        selectComponentCondition={this.props.selectComponentCondition}
                        idCurrentConditionComponent={currentComponentCondition.id}
                        getConditionOptionCompare={this.getConditionOptionCompare}
                        onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                        onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                        onChangeComponent={() => this.onChangeComponent(idxCondition, idxRule)}
                        valueOption={sectionCondition.xItem.prop}
                        valueOptionCompare={sectionCondition.operator}
                        valueComponents={sectionCondition.yItem.id}
                      />
                    </div>
                  }
                  {
                    sectionCondition.compare === 'value' &&
                    <ConditionWithValueWithoutProp
                      isSelect={false}
                      selectComponentCondition={this.props.selectComponentCondition}
                      idCurrentConditionComponent={currentComponentCondition.id}
                      title={I18n.l("formflow.conditions.goToTitle")}
                      getConditionOptionCompare={this.getConditionOptionCompareCount}
                      onChangeOptionCompare={() => this.onChangeOptionCompareWithoutXProp(idxCondition, idxRule)}
                      onChangeValue={() => this.onChangeValueNumber(idxCondition, idxRule)}
                      valueOptionCompare={sectionCondition.operator}
                      valueInput={sectionCondition.value}
                    />
                  }
                </React.Fragment>
              </div>
            </React.Fragment>
          )
        }
        case ComponentType.PHOTO: {
          return (
            <React.Fragment>
              <div>
                <p className="title-component" >{currentComponentCondition.title}</p>
                <React.Fragment>
                  <div style={{ marginBottom: '10px', position: "relative" }} id="area">
                    {sectionCondition.compare !== undefined &&
                      <Select defaultValue={sectionCondition.compare} placeholder={I18n.l("formflow.conditions.selectOptionPlaceholder")} style={{ width: "50%", marginBottom: '10px', marginTop: '10px' }}
                        onChange={this.onChangeCompareComponents(idxCondition, idxRule)}
                        getPopupContainer={() => document.getElementById("area")}
                      >
                        <Option value="component">{I18n.l("formflow.conditions.compareComponent")}</Option>
                        <Option value="value">{I18n.l("formflow.conditions.compareValue")}</Option>
                      </Select>
                    }
                    <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}` }} >
                      {sectionCondition.compare !== 'value' && sectionCondition.compare !== 'component' && I18n.l("form.validation.field.required")}
                    </div>
                  </div>
                  {
                    sectionCondition.compare === 'component' &&
                    <div>
                      <ConditionWithComponent
                        selectComponentCondition={this.props.selectComponentCondition}
                        idCurrentConditionComponent={currentComponentCondition.id}
                        getConditionOptionCompare={this.getConditionOptionCompare}
                        onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                        onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                        onChangeComponent={() => this.onChangeComponent(idxCondition, idxRule)}
                        valueOption={sectionCondition.xItem.prop}
                        valueOptionCompare={sectionCondition.operator}
                        valueComponents={sectionCondition.yItem.id}
                      />
                    </div>
                  }
                  {
                    sectionCondition.compare === 'value' &&
                    <ConditionWithValueWithoutProp
                      isSelect={false}
                      selectComponentCondition={this.props.selectComponentCondition}
                      idCurrentConditionComponent={currentComponentCondition.id}
                      title={I18n.l("formflow.conditions.photoTitle")}
                      getConditionOptionCompare={this.getConditionOptionCompareCount}
                      onChangeOptionCompare={() => this.onChangeOptionCompareWithoutXProp(idxCondition, idxRule)}
                      onChangeValue={() => this.onChangeValueNumber(idxCondition, idxRule)}
                      valueOptionCompare={sectionCondition.operator}
                      valueInput={sectionCondition.value}
                    />
                  }

                </React.Fragment>
              </div>
            </React.Fragment>
          )
        }
        case ComponentType.DATE: {
          return (
            <React.Fragment>
              <div>
                <p className="title-component" >{currentComponentCondition.title}</p>
                <React.Fragment>
                  <div style={{ marginBottom: '10px', position: "relative" }} id="area">
                    {sectionCondition.compare !== undefined &&
                      <Select defaultValue={sectionCondition.compare} placeholder={I18n.l("formflow.conditions.selectOptionPlaceholder")} style={{ width: "50%", marginBottom: '10px', marginTop: '10px' }}
                        onChange={this.onChangeCompareComponents(idxCondition, idxRule)}
                        getPopupContainer={() => document.getElementById("area")}
                      >
                        <Option value="component">{I18n.l("formflow.conditions.compareComponent")}</Option>
                        <Option value="value">{I18n.l("formflow.conditions.compareValue")}</Option>
                      </Select>
                    }
                    <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}` }} >
                      {sectionCondition.compare !== 'value' && sectionCondition.compare !== 'component' && I18n.l("form.validation.field.required")}
                    </div>
                  </div>
                  {
                    sectionCondition.compare === 'component' &&
                    <div>
                      <ConditionWithComponent
                        selectComponentCondition={this.props.selectComponentCondition}
                        idCurrentConditionComponent={currentComponentCondition.id}
                        getConditionOptionCompare={this.getConditionOptionCompare}
                        onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                        onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                        onChangeComponent={() => this.onChangeComponent(idxCondition, idxRule)}
                        valueOption={sectionCondition.xItem.prop}
                        valueOptionCompare={sectionCondition.operator}
                        valueComponents={sectionCondition.yItem.id}
                      />
                    </div>
                  }
                  {
                    sectionCondition.compare === 'value' &&
                    <ConditionWithValue
                      withoutCount={true}
                      selectComponentCondition={this.props.selectComponentCondition}
                      idCurrentConditionComponent={currentComponentCondition.id}
                      getConditionOptionCompare={this.getConditionOptionCompareCount}
                      onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                      onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                      onChangeValue={() => this.onChangeValue(idxCondition, idxRule)}
                      valueOption={sectionCondition.xItem.prop}
                      valueOptionCompare={sectionCondition.operator}
                      valueInput={sectionCondition.value}
                    />
                  }

                </React.Fragment>
              </div>
            </React.Fragment>
          )
        }
        case ComponentType.SELECT: {
          return (
            <React.Fragment>
              <div>
                <p className="title-component" >{currentComponentCondition.title}</p>
                <React.Fragment>
                  <div style={{ marginBottom: '10px', position: "relative" }} id="area" >
                    {sectionCondition.compare !== undefined &&
                      <Select defaultValue={sectionCondition.compare} placeholder={I18n.l("formflow.conditions.selectOptionPlaceholder")} style={{ width: "50%", marginBottom: '10px', marginTop: '10px' }}
                        onChange={this.onChangeCompareComponents(idxCondition, idxRule)}
                        getPopupContainer={() => document.getElementById("area")}
                      >
                        <Option value="component">{I18n.l("formflow.conditions.compareComponent")}</Option>
                        <Option value="value">{I18n.l("formflow.conditions.compareValue")}</Option>
                      </Select>
                    }
                    <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}` }} >
                      {sectionCondition.compare !== 'value' && sectionCondition.compare !== 'component' && I18n.l("form.validation.field.required")}
                    </div>
                  </div>
                  {
                    sectionCondition.compare === 'component' &&
                    <div>
                      <ConditionWithComponent
                        selectComponentCondition={this.props.selectComponentCondition}
                        idCurrentConditionComponent={currentComponentCondition.id}
                        getConditionOptionCompare={this.getConditionOptionCompare}
                        onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                        onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                        onChangeComponent={() => this.onChangeComponent(idxCondition, idxRule)}
                        valueOption={sectionCondition.xItem.prop}
                        valueOptionCompare={sectionCondition.operator}
                        valueComponents={sectionCondition.yItem.id}
                      />
                    </div>
                  }
                  {
                    sectionCondition.compare === 'value' && currentComponentCondition.multiple === true &&
                    <ConditionWithValue
                      withoutCount={true}
                      selectComponentCondition={this.props.selectComponentCondition}
                      idCurrentConditionComponent={currentComponentCondition.id}
                      getConditionOptionCompare={this.getConditionOptionCompareCount}
                      onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                      onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                      onChangeValue={() => this.onChangeValueSelect(idxCondition, idxRule, currentComponentCondition)}
                      valueOption={sectionCondition.xItem.prop}
                      valueOptionCompare={sectionCondition.operator}
                      valueInput={sectionCondition.value}
                    />
                  }
                  {
                    sectionCondition.compare === 'value' && currentComponentCondition.multiple === false &&
                    <ConditionWithValueWithoutProp
                      isSelect={true}
                      selectComponentCondition={this.props.selectComponentCondition}
                      idCurrentConditionComponent={currentComponentCondition.id}
                      title={I18n.l("formflow.conditions.selectTitle")}
                      getConditionOptionCompare={this.getConditionOptionCompareSelect}
                      onChangeOptionCompare={() => this.onChangeOptionCompareWithoutXProp(idxCondition, idxRule)}
                      onChangeComponent={() => this.onChangeValueSelect(idxCondition, idxRule, currentComponentCondition)}
                      valueOptionCompare={sectionCondition.operator}
                      // valueComponents={currentComponentCondition.options[sectionCondition.value].value}
                      valueComponents={sectionCondition.value !== undefined ? currentComponentCondition.options[sectionCondition.value].value : sectionCondition.value}
                      getConditionComponents={() => this.getSelectItems(currentComponentCondition.options)}
                    />
                  }
                  {console.log('current Condition', currentComponentCondition)}
                </React.Fragment>
              </div>
            </React.Fragment>
          )
        }
        case ComponentType.NUMBER: {
          return (
            <React.Fragment>
              <div>
                <p className="title-component" >{currentComponentCondition.title}</p>
                <React.Fragment>
                  <div style={{ marginBottom: '10px', position: "relative" }} id="area">
                    {sectionCondition.compare !== undefined &&
                      <Select defaultValue={sectionCondition.compare} placeholder={I18n.l("formflow.conditions.selectOptionPlaceholder")} style={{ width: "50%", marginBottom: '10px', marginTop: '10px' }}
                        onChange={this.onChangeCompareComponents(idxCondition, idxRule)}
                        getPopupContainer={() => document.getElementById("area")}
                      >
                        <Option value="component">{I18n.l("formflow.conditions.compareComponent")}</Option>
                        <Option value="value">{I18n.l("formflow.conditions.compareValue")}</Option>
                      </Select>
                    }
                    <div style={{ fontWeight: 'bold', color: `${Theme.secondary.red}` }} >
                      {sectionCondition.compare !== 'value' && sectionCondition.compare !== 'component' && I18n.l("form.validation.field.required")}
                    </div>
                  </div>
                  {
                    sectionCondition.compare === 'component' &&
                    <div>
                      <ConditionWithComponent
                        selectComponentCondition={this.props.selectComponentCondition}
                        idCurrentConditionComponent={currentComponentCondition.id}
                        getConditionOptionCompare={this.getConditionOptionCompare}
                        onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                        onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                        onChangeComponent={() => this.onChangeComponent(idxCondition, idxRule)}
                        valueOption={sectionCondition.xItem.prop}
                        valueOptionCompare={sectionCondition.operator}
                        valueComponents={sectionCondition.yItem.id}
                      />
                    </div>
                  }
                  {
                    sectionCondition.compare === 'value' &&
                    <ConditionWithValue
                      withoutCount={false}
                      selectComponentCondition={this.props.selectComponentCondition}
                      idCurrentConditionComponent={currentComponentCondition.id}
                      getConditionOptionCompare={this.state.propsXItem === ComponentProp.COUNT ? this.getConditionOptionCompareCount : this.state.propsXItem === ComponentProp.VALUE ? this.getConditionOptionAllCompare : this.getConditionOptionCompare}
                      onChangeOption={() => this.onChangeOption(idxCondition, idxRule)}
                      onChangeOptionCompare={() => this.onChangeOptionCompare(idxCondition, idxRule)}
                      onChangeValue={() => this.onChangeValue(idxCondition, idxRule)}
                      valueOption={sectionCondition.xItem.prop}
                      valueOptionCompare={sectionCondition.operator}
                      valueInput={sectionCondition.value}
                    />
                  }

                </React.Fragment>
              </div>
            </React.Fragment>
          )
        }
        default: {
          return;
        }
      }
    }
    else {
      return;
    }
  }

  getConditionComponents = () => {
    const conditionsComponent: JSX.Element[] = [];
    this.props.selectComponentCondition.forEach((components: any, idx: number) => {
      if (components.type !== ComponentType.GPS && components.type !== ComponentType.MODEL) {
        conditionsComponent.push(
          <Option key={idx} value={components.id}>
            {components.title}
          </Option>
        );
      }

    })
    return conditionsComponent;
  }
  //#region Validation COnditions
  validationConditions(conditionsItems: ISectionCondition) {
    let fieldIsRequired: JSX.Element = <div />;
    console.log('VALIDATION', conditionsItems)
    if (!!!conditionsItems.id || conditionsItems.id !== undefined && conditionsItems.id.length === 0 && this.state.validationConditions.length > 0) {
      fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
    }
    if (conditionsItems.id !== undefined && conditionsItems.id.length < 3 && conditionsItems.id.length > 0) {
      fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("formflow.labels.validationToShort")}</span>)
    }
    return fieldIsRequired;
  }
  validationSelectConditions(rulesItems: ISectionConditionRole) {
    let fieldIsRequired: JSX.Element = <div />;
    if (rulesItems.xItem.id === undefined) {
      fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
    }
    return fieldIsRequired;
  }
  validationSelectSectionIDConditions(conditionsItems: ISectionCondition) {
    let fieldIsRequired: JSX.Element = <div />;
    if (conditionsItems.sectionId === undefined) {
      fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
    }
    return fieldIsRequired;
  }
  //#endregion 

  onSaveCondition = async (updateFormflowWithCondition: (condition: ISectionCondition[], currentSection: ISection) => void) => {

    for (let conditions of this.state.conditionsSections) {
      if (conditions.sectionId !== undefined) {
        this.setState({ validationConditions: [] })
      }

      if (!conditions.id) {
        validationConditions.push(false)
        this.setState({ validationConditions: validationConditions })
      }
      else if (conditions.id === undefined || conditions.id.length < 3) {
        validationConditions.push(false)
        this.setState({ validationConditions: validationConditions })
      }
      else if (conditions.id !== undefined || conditions.id.length > 3) {
        this.setState({ validationConditions: [] })
      }
      if (conditions.sectionId === undefined) {
        validationConditions.push(false)
        this.setState({ validationConditions: validationConditions })
      }
      else if (conditions.id !== undefined && conditions.id.length > 3 && conditions.sectionId !== undefined) {
        this.setState({ validationConditions: [] })
      }

      for (let rulesItems of conditions.rules) {
        console.log('rules', rulesItems)
        if (rulesItems.xItem.id === undefined) {
          validationConditions.push(false)
          this.setState({ validationConditions: validationConditions })
        }
        else if (rulesItems.value === undefined) {
          validationConditions.push(false)
          this.setState({ validationConditions: validationConditions })
        }
        else if (rulesItems.compare !== 'value' && rulesItems.compare !== 'component' && rulesItems.value !== true && rulesItems.value !== false) {
          validationConditions.push(false)
          this.setState({ validationConditions: validationConditions })
        }
        else if (rulesItems.operator === undefined) {
          validationConditions.push(false)
          this.setState({ validationConditions: validationConditions })
        }
        else if (rulesItems.yItem !== null && rulesItems.yItem !== undefined) {
          if (rulesItems.yItem.id === undefined) {
            validationConditions.push(false)
            this.setState({ validationConditions: validationConditions })
          }
        }
      }
    }
    if (this.state.validationConditions.length === 0) {
      updateFormflowWithCondition(this.state.conditionsSections, this.props.currentSection);
      this.props.onCloseModal()

    }
    else {
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('process.execution.fieldsNotFilled'));
    }
    console.log('entrou aqui', this.state.validationConditions)
  }

  render() {
    const {
      modalVisible,
      titleConditionModal,
      subtitleConditionModal,
    } = this.props;

    return (

      <Wrapper >
        <Modal
          className="section-condition-fullscreen"
          destroyOnClose={true}
          footer={false}
          visible={modalVisible}
          closable={false}
        >
          <FontStyle>
            <h1>{titleConditionModal}</h1>
            <h3 className="subtitle-section" >{subtitleConditionModal}</h3>
            <p className="description-condition" >{I18n.l("formflow.labels.descriptionLinked")}</p>
            <p className="subdescription-condition" >{I18n.l("formflow.labels.subdescriptionLinked")}</p>
            <Spacing />
          </FontStyle>
          {this.state.conditionsSections.map((conditionSectionItems: any, idxSection: number) => (
            <ConditionContainerStyle key={idxSection}>
              <React.Fragment>
                <p className="title-condition" >{I18n.l("formflow.labels.condition") + ' ' + (idxSection + 1)}</p>
                < div className="item-container-condition" >
                  <div className="input-style">
                    <Input
                      defaultValue={conditionSectionItems.id}
                      style={!!!conditionSectionItems.id ||
                        conditionSectionItems.id !== undefined && conditionSectionItems.id.length === 0
                        || conditionSectionItems.id !== undefined && conditionSectionItems.id.length < 3 && conditionSectionItems.id.length > 0 ?
                        { borderColor: `${Theme.secondary.red}` } : {}}
                      placeholder={I18n.l("formflow.labels.nameConditionPlaceholder")}
                      className={conditionSectionItems.id !== undefined && conditionSectionItems.id.length === 30 ? "apply-shake" : ''}
                      minLength={3}
                      maxLength={30}
                      onChange={this.onChangeNameCondition(idxSection)}
                    />
                    {this.validationConditions(conditionSectionItems)}
                    <p style={{ float: 'right' }} className={conditionSectionItems.id !== undefined && conditionSectionItems.id.length < 30 ? "count-input" : "count-input-red"} >
                      {conditionSectionItems.id !== undefined && conditionSectionItems.id.length !== 0 ? conditionSectionItems.id.length + ' / 30' : '0 / 30'}
                    </p>
                  </div>
                  {conditionSectionItems.rules.map((rulesItems: any, idxRules: number) => (
                    <React.Fragment>
                      <div >
                        <span style={{ position: "relative" }} id="area">
                          < Select key={idxRules}
                            defaultValue={rulesItems.xItem.id}
                            getPopupContainer={() => document.getElementById("area")}
                            className={rulesItems.xItem.id === undefined ? ".ant-select-selection--single" : ''}
                            style={{ width: '21%', marginTop: '1.5rem' }}
                            placeholder={I18n.l("formflow.labels.selectComponentConditionPlaceholder")}
                            onChange={this.onChangeSelectComponetCondition(idxSection, idxRules)}
                          >
                            {this.getConditionComponents()}
                          </Select>
                          {
                            conditionSectionItems.rules.length > 1 &&
                            <Icon
                              style={{ marginLeft: '10px', color: 'red', cursor: "pointer" }}
                              type="close"
                              onClick={this.handleRemoveRules(idxSection, idxRules, conditionSectionItems.rules)}
                            />
                          }
                          <div>{this.validationSelectConditions(rulesItems)}</div>
                        </span>
                        <div className="confirm-condition" >
                          {
                            this.renderConditionComponent(
                              conditionSectionItems.rules[idxRules],
                              idxSection,
                              idxRules
                            )
                          }
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                  {
                    conditionSectionItems.rules[0].xItem.id !== undefined &&
                    < Button style={{ marginLeft: '-15px', fontWeight: 'bold', marginBottom: '16px' }} onClick={() => this.handleAddNewRules(conditionSectionItems.rules, idxSection)} className="goepik-btn-border-main-withoutbold">
                      <Icon type="plus" /> {I18n.l("formflow.buttons.addComponent")}
                    </Button>
                  }
                  <React.Fragment>
                    {
                      conditionSectionItems.rules[0].xItem.id !== undefined &&
                      <div style={{ position: "relative" }} id="area">
                        <span style={{ marginRight: ' 5px' }} >{I18n.l("formflow.labels.nextSectionSelect")}</span>
                        <Select
                          style={{ width: '20%' }}
                          placeholder={I18n.l("formflow.conditions.selectSectionPlaceholder")}
                          getPopupContainer={() => document.getElementById("area")}
                          defaultValue={conditionSectionItems.sectionId}
                          onChange={this.onChangeSelectLinkCondition(idxSection)} key={1} className="select-condition-link" >
                          {this.props.sectionLinkedCondition.map((titleLinks: any, idx: number) => {
                            return <Option key={idx + 1} value={titleLinks}>
                              {
                                (titleLinks === '') &&
                                I18n.l("formflow.labels.section") + " " + (idx + 1)
                              }
                              {(titleLinks !== '') &&
                                titleLinks
                              }
                            </Option>
                          })}
                        </Select>
                        <div>{this.validationSelectSectionIDConditions(conditionSectionItems)}</div>
                      </div>
                    }
                    {
                      this.state.conditionsSections.length > 1 &&
                      <Button style={{ border: '0px', marginLeft: '-15px' }} type="danger" ghost onClick={this.handleRemoveConditionSection(idxSection)}  >
                        {I18n.l("common.delete")}
                      </Button>
                    }
                  </React.Fragment>
                </div>
              </React.Fragment>
            </ConditionContainerStyle>

          ))}
          <Button style={{ marginTop: '15px' }} ghost onClick={this.handleAddNewConditionSection} className="goepik-btn-border-main">
            <Icon type="plus" /> {I18n.l("formflow.buttons.addNewCondition").toUpperCase()}
          </Button>
          <FormflowContext.Consumer>
            {({ updateFormflowWithCondition }) => (
              <ButtonStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" ghost onClick={() => this.props.onCloseModal()} >{I18n.l('common.cancel')}</Button>
                  <Button className="button-save" type="primary" onClick={() => { this.onSaveCondition(updateFormflowWithCondition) }} htmlType="submit" >{I18n.l('common.save')}</Button>
                </Row>
              </ButtonStyle>
            )}
          </FormflowContext.Consumer>

        </Modal>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
    width: 100%;
    button-style {
        position:relative;
        margin-top:100%;
        }
        
`
const ConditionContainerStyle = styled.div`
    margin-top: 3rem;
    .title-condition{
        font-weight: bold;
        margin-bottom: 10px;
        color: ${Theme.secondary.black}
    }
    .confirm-condition{
        margin-top: 1rem;
    }
    .title-component{
        margin-bottom: 2rem;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .item-container-condition{
        cursor:pointer;
        height: auto;
        background-color: ${Theme.secondary.supahLightGrey};
        border: 1px solid ${Theme.secondary.midLightGrey};
        border-radius: 5px;
        text-align: left;
        padding: 1.2rem;
        margin-bottom: 1rem;
    }

    .ant-select-selection--single {
      height: 32px;
      position: relative;
      cursor: pointer;
  }
  .select-condition-component{
    background: ${Theme.secondary.red};
  }
    .ant-select-disabled .ant-select-selection {
        background: ${Theme.secondary.white};
        cursor: not-allowed;
        color: ${Theme.secondary.darkGrey};
    }
    .select-condition-link{
        width: 15%;
    }
    .divider {
        display: block;
        border-bottom: 1px solid ${Theme.secondary.midLightGrey};
        height: 1px;
        width: 100%;
        margin: 24px 0;
        clear: both;
    }
    .input-style{
      width 50%;
  }
    
    .count-input{
      margin-top:2px;
      font-weight: bold;
      color: ${Theme.secondary.midGrey};
  }
  .count-input-red{
      margin-top:2px;
      color: ${Theme.secondary.red};
      font-weight: bold;
  }
  @keyframes shake {
      10%, 90% {
          transform: translate3d(-1px, 0, 0);
      }
    
      20%, 80% {
          transform: translate3d(2px, 0, 0);
      }
    
      30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
      }
    
      40%, 60% {
          transform: translate3d(4px, 0, 0);
      }
  }

  .apply-shake {
      animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  }
        `;
const Spacing = styled.div`
            margin-top: 2rem;
        `;
const FontStyle = styled.div`
    border-bottom: 1px solid ${Theme.secondary.midGrey};
    .subtitle-section{
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
        margin-top: -1rem;
    }
    .description-condition{
        font-weight: bold;
        color: ${Theme.secondary.black};
        margin-top: 2rem;
    }
    .subdescription-condition{
        font-weight: bold;
        color: ${Theme.secondary.black};
    }
`
const ButtonStyle = styled.div`
    float:right;
    padding-top: 50px;
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`

